import { Row } from 'antd';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { UserStore } from '../../stores';
import { ConsultaStore } from '../../stores/consultaStore';
import ConsultasHeader from './ConsultasHeader';
import ConsultasTables from './ConsultasTable';
import { ConsultaMensual } from './ConsultaMensual';

const ConsultasWrapper = styled.div`
    margin: 0 auto;
    padding: 0 150px;
    max-width: 1600px;
`;

interface NotificacionesProps extends RouteComponentProps {
    consultaStore?: ConsultaStore;
    userStore?:UserStore;
}

@inject('consultaStore')
@inject('userStore')
@observer
class ConsultasImpuestosInner extends React.Component<NotificacionesProps, {}> {
    async componentDidMount() {
        const { consultaStore, userStore } = this.props;
        await userStore!.getUsuario();
        consultaStore!.inicializarFiltros();
        const fecha = new Date();
        consultaStore!.filtros!.Ejercicio = fecha.getFullYear();
        consultaStore!.filtros!.Mes = 1;
        switch(userStore!.rol){
            case 'ROL-ROO':
                consultaStore!.listaMunicipios=userStore!.municipio;
            break;
            case 'ROL-RM':
                consultaStore!.filtros!.Municipio=userStore!.municipio[0].id;
            break;
            default:
                await consultaStore!.getMunicipios();
                await consultaStore!.getConsultaMensual();
            break;
        }
        await consultaStore!.getConsulta(true);
    }

    render() {
        const { rol } = this.props.userStore!;
        let paintConsultaMensual = rol && (rol.includes('ROO') || rol.includes('RM'));
        return (
            <>
                <ConsultasWrapper>
                    <Row className="justify-content-md-center">
                        <ConsultasHeader />
                    </Row>
                    {!paintConsultaMensual && (
                        <Row>
                            <ConsultaMensual />
                        </Row>
                    )}
                    <Row>
                        <ConsultasTables />
                    </Row>
                </ConsultasWrapper>
            </>
        );
    }
}

export const  ConsultasImpuestos = withRouter(ConsultasImpuestosInner);
